import { useInstagramConnect, useIsProviderConnected, useDisconnectSocialProvider } from '@/api';
import { SocialProvider } from '@/api/queries/settings/constants';
import { ConnectSocialPage } from '@/components';
import { redirectToOAuth } from '@/utils/oauth';

export function ConnectInstagram() {
  const { isConnected, username, isLoading } = useIsProviderConnected(SocialProvider.INSTAGRAM);
  const { mutateAsync, isPending: isConnecting, error: connectError } = useInstagramConnect();
  const {
    mutateAsync: disconnect,
    isPending: isDisconnecting,
    error: disconnectError,
  } = useDisconnectSocialProvider();

  const handleConnect = async () => {
    const { url } = await mutateAsync();
    redirectToOAuth(url, SocialProvider.INSTAGRAM);
  };

  return (
    <ConnectSocialPage
      providerName="Instagram"
      icon="instagram"
      isConnected={isConnected}
      username={username}
      isLoadingConnection={isLoading}
      isConnecting={isConnecting}
      isDisconnecting={isDisconnecting}
      error={
        (connectError instanceof Error ? connectError.message : '') ||
        (disconnectError instanceof Error ? disconnectError.message : '')
      }
      onConnect={handleConnect}
      onDisconnect={() => disconnect(SocialProvider.INSTAGRAM)}
    />
  );
}

export default ConnectInstagram;
